export const is_function = obj => typeof obj === "function"
